import { cn } from "@/lib/utils";

type TCompactTableColumn<T extends Record<string, string>> = {
	key: keyof T & string;
	header: string;
	widthClass?: string;
	headerClassName?: string;
	cellClassName?: string;
};

type TCompactTableProps<T extends Record<string, string>> = {
	columns: readonly TCompactTableColumn<T>[];
	rows: readonly T[];
	rowKey: keyof T & string;
	className?: string;
	headCellClassName?: string;
	bodyCellClassName?: string;
};

const DEFAULT_HEAD =
	"h-[34px] overflow-hidden border border-grey-700 bg-white px-3 text-left text-[10.8px] font-bold text-ellipsis whitespace-nowrap text-teal-500 max-md:h-[34px] max-md:px-[7px] max-md:text-[8.5px]";

const DEFAULT_CELL =
	"h-[37px] overflow-hidden border border-grey-700 bg-transparent px-3 text-left text-ellipsis whitespace-nowrap max-md:h-[34px] max-md:px-[7px] max-md:text-[8px]";

export function CompactTable<T extends Record<string, string>>({
	columns,
	rows,
	rowKey,
	className,
	headCellClassName = DEFAULT_HEAD,
	bodyCellClassName = DEFAULT_CELL,
}: TCompactTableProps<T>) {
	return (
		<table
			className={cn(
				"w-full table-fixed border-collapse font-sans text-[10px] tracking-[-0.01em] text-grey-1000",
				className,
			)}
		>
			<thead>
				<tr>
					{columns.map((column) => (
						<th
							key={column.key}
							scope="col"
							className={cn(headCellClassName, column.widthClass, column.headerClassName)}
						>
							{column.header}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{rows.map((row) => (
					<tr key={row[rowKey]}>
						{columns.map((column) => (
							<td key={column.key} className={cn(bodyCellClassName, column.widthClass, column.cellClassName)}>
								{row[column.key]}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);
}
